import { FC } from "react";

import { PanelTop } from "@ryde/layout";

import { ProduceButtonsTopStatLine } from "./produce-buttons.top-stat.line";

export const PanelTopLeftProduceButton: FC = () => {
  return <PanelTop StartAddition={<ProduceButtonsTopStatLine />} />;
};
